<ng-container *ngIf="salespersonOptions$$ | async as salespersonOptions">
  <glxy-form-field>
    <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_OPPORTUNITY.ASSIGN_TO' | translate }}</glxy-label>
    <mat-select [formControl]="salespersonControl">
      <mat-option *ngFor="let user of salespersonOptions" [value]="user.salespersonId">
        {{ user.firstName }} {{ user.lastName }}
      </mat-option>
      <glxy-infinite-scroll-trigger [visiblilityMargin]="120" (isVisible)="loadMore()"></glxy-infinite-scroll-trigger>
    </mat-select>
    <mat-error *ngIf="salespersonControl.hasError('required')">
      {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_EMAIL_NOTIFICATION.REQUIRED_FIELD' | translate }}
    </mat-error>
  </glxy-form-field>
</ng-container>
